export default {
  'label/title': 'Mi plan',
  'label/payment_method': 'Forma de Pago',
  'label/credit_card': 'Tarjeta de Crédito',
  'label/boleto': 'Boleto o PIX',
  'label/special': 'Especial',
  'label/inactive': 'Inactivo',
  'label/sms_credits': 'Crédito restante',
  'action/talk_support': 'Hablar con Soporte',
  'action/updated_credit_card': 'Actualizar Tarjeta',
  'action/cancel_sms_plan': 'Cancelar Plan de SMS',
  'action/request_sms_plan': 'Contratar Plan de SMS',
  'action/change_plan': 'Cambiar Plan',
  'action/manage_plan_and_payments': 'Gestionar Plan y Pagos',
  'label/opening_billing': 'Abriendo...',
  'action/pay': 'Pagar',
  'action/cancel_plan': 'Cancelar Suscripción',
  'action/subscribe_again': 'Suscribirse de Nuevo',
  'action/see_plans': 'Ver planes',
  // V2
  'label/need_help': '¿Necesitas ayuda?',




  'label/boleto_active_without_charge/title': 'Texto aquí para Sin cargo XD',
  'label/boleto_active_without_charge/text_line_1': 'lorem impsum.',
  'label/boleto_active_without_charge/text_line_2': 'lorem impsum lorem impsum',



  'action/request_new_boleto': 'Generar Nuevo Boleto',
  'action/view_boleto': 'Ver Boleto',
  'label/plan': 'Plan',

  'label/sms_title': 'SMS',
  'label/sms_credits_2': 'Saldo Restante de SMS',
  'action/details': 'Detalles',

  'label/boleto_message_days': 'Recibirás un boleto por correo electrónico, siempre 5 días antes de la fecha de vencimiento',
  'action/fix_payment_info_problems_label': 'DATOS DE PAGO',
  'action/fix_payment_info_problems': 'Tus datos de pago están incompletos',
  'action/fix_payment_info_problems_edit': 'Editar',
  // An iOS build in App Store review: the plan's name, nothing about paying
  'store_review/plan': 'Tu plan',
  'store_review/active_text': 'Tu suscripción está activa.',
  'store_review/inactive_text': 'Tu suscripción no está activa. Habla con soporte para regularizarla.',
  'store_review/app_store_text': 'Tu suscripción es por la App Store. Para cambiarla o cancelarla, usa la App Store.',
  'store_review/app_store_manage': 'Gestionar en la App Store',
  'store_review/support': 'Hablar con soporte',
  // Meu Plano: the plan card (PlanSummary)
  'summary/your_plan': 'Tu plan',
  'summary/per_month': '/mes',
  'summary/per_year': '/año',
  'summary/state/active': 'Activa',
  'summary/state/app_store': 'Activa',
  'summary/state/app_store_inactive': 'Inactiva',
  'summary/state/blocked': 'Cuenta bloqueada',
  'summary/state/boleto_late': 'Pago pendiente',
  'summary/state/will_cancel': 'Cancelación programada',
  'summary/state/payment_failed': 'Pago pendiente',
  'summary/state/boleto_open': 'Boleto pendiente',
  'summary/state/boleto_overdue': 'Pago pendiente',
  'summary/state/canceled': 'Cancelada',
  'summary/state/trial_ended': 'Prueba terminada',
  'summary/state/inactive': 'Inactiva',
  'summary/next_charge': 'Próximo cobro el {0}.',
  'summary/app_store': 'Pagada por la App Store.',
  'summary/app_store_inactive': 'Tu suscripción por la App Store no está activa.',
  'summary/will_cancel': 'Tu suscripción termina el {0}.',
  'summary/payment_failed': 'La suscripción venció el {0} y aún no identificamos el pago. Paga para mantener tu cuenta activa.',
  'summary/payment_failed_nodate': 'Aún no identificamos el pago de la suscripción. Paga para mantener tu cuenta activa.',
  'summary/blocked': 'Tu cuenta está bloqueada: la suscripción venció el {0} y no identificamos el pago. Paga para desbloquearla.',
  'summary/blocked_nodate': 'Tu cuenta está bloqueada porque no identificamos el pago. Paga para desbloquearla.',
  'summary/boleto_open': 'El boleto de R$ {0} vence el {1}. Si ya pagaste, la confirmación tarda hasta 3 días hábiles.',
  'summary/boleto_late': 'La suscripción venció el {0} y aún no identificamos el pago. El boleto de R$ {1} vence el {2}.',
  'summary/boleto_overdue': 'El boleto venció el {0}. Paga ahora para mantener tu cuenta activa.',
  'summary/canceled': 'Tu suscripción está cancelada.',
  'summary/trial_ended': 'Tu período de prueba terminó.',
  'summary/inactive': 'Tu suscripción no está activa. Habla con soporte para regularizarla.',
  'summary/pay_now': 'Pagar ahora',
  'summary/deal': 'Detalles de la suscripción',
  'summary/load_error': 'No pudimos cargar tu suscripción. Inténtalo de nuevo en unos instantes.',
  'summary/help': '¿Dudas sobre tu suscripción?',
  'blocked_notice/title': 'Tu suscripción no está activa',
  'blocked_notice/trial_title': 'Tu período de prueba terminó',
  'blocked_notice/dependent_title': 'La suscripción de la clínica no está activa',
  'blocked_notice/settings': 'La agenda, los pacientes y los informes vuelven cuando haya una suscripción activa. Mientras tanto, aquí ves tu perfil, hablas con soporte y puedes cerrar sesión.',
  'blocked_notice/plan': 'La agenda, los pacientes y los informes vuelven cuando haya una suscripción activa.',
  'blocked_notice/dependent_settings': 'La agenda, los pacientes y los informes vuelven cuando el responsable de la clínica regularice la suscripción. Mientras tanto, aquí ves tu perfil, hablas con soporte y puedes cerrar sesión.',
  'blocked_notice/dependent_plan': 'La agenda, los pacientes y los informes vuelven cuando el responsable de la clínica regularice la suscripción.',
  'summary/help_link': 'Hablar con soporte',
  // Meu Plano: moving an App Store subscription to the Doutore (AppStoreSwitch, web and Android only)
  'switch/title': 'Suscríbete directo con Doutore',
  'switch/why': 'Hoy pagas por la App Store. Suscribiéndote directo con Doutore, el cobro, las facturas y el cambio de plan quedan en tu cuenta de Doutore, sin depender de la App Store.',
  'switch/step1_title': 'Cancela la renovación en la App Store',
  'switch/step1_text': 'En el iPhone: Ajustes › tu nombre › Suscripciones › Doutore › Cancelar suscripción. Sigues usando Doutore hasta el final del período ya pagado.',
  'switch/step1_button': 'Abrir las suscripciones de la App Store',
  'switch/step2_title': 'Después, suscríbete con Doutore',
  'switch/step2_text': 'Cuando termine el período pagado en la App Store, habla con nosotros y activamos tu suscripción directo con Doutore.',
  'switch/step2_support': 'Hablar con soporte',
};
